
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consultant/[consultant]",
      function () {
        return require("private-next-pages/consultant/[consultant].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/consultant/[consultant]"])
      });
    }
  